import { Entity, Version } from "../../types";
import { Car, CarState } from "../cars/types";
import { LeasingCompany } from "../leasingCompanies/types";

// car leasing does not have an own id, it is related 1:1 to the car, so it main id is the car id
export type CarLeasing = Omit<Entity, "id"> & {
  car: Car;
  leasingCompany: LeasingCompany;
  contractDate: string;
  contractDetails?: string;
  expirationDate: string;
};

export type CarLeasingNoCarDepency = Omit<CarLeasing, "car"> & {
  car: {
    id: string;
    vehicleIdentificationNumber: string;
    currentPlateNumber?: string;
    lastPlateNumber?: string;
    status: CarState;
  };
};

export type CarLeasingVersion = Version & {
  car: Car;
  leasingCompany?: LeasingCompany;
  contractDate: string;
  contractDetails?: string;
  expirationDate: string;
};

export type InsertCarLeasing = {
  carId: string;
  leasingCompanyId: string;
  contractDate: string;
  contractDetails?: string;
  expirationDate: string;
  currentVersionNumber?: number;
};

export type UpdateCarLeasing = {
  leasingCompanyId: string;
  contractDate: string;
  contractDetails?: string;
  expirationDate: string;
  currentVersionNumber?: number;
};

export type CarLeasingStats = {
  totalActive: number;
  totalExpiringSoon: number;
  totalExpired: number;
};

export const isItemExpiringSoon = (expirationDate: string, state: string): boolean => {
  const d = new Date(expirationDate);
  const today = new Date();
  const limit = new Date();
  limit.setDate(today.getDate() + 21);
  if (d < limit && d >= today && state == "active") {
    return true;
  }

  return false;
};

export const isItemExpired = (expirationDate: string, state: string): boolean => {
  const d = new Date(expirationDate);
  const today = new Date();
  const limit = new Date();
  limit.setDate(today.getDate() + 21);
  if (d < limit && d < today && state == "active") {
    return true;
  }

  return false;
};
